import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import WorldPage from "@/pages/WorldPage";
import Assessment from "@/pages/Assessment";
import Contact from "@/pages/Contact";
import { Login, Signup } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Store from "@/pages/Store";
import AdminOrders from "@/pages/AdminOrders";
import BladeGrain from "@/pages/BladeGrain";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/transform" element={<WorldPage />} />
      <Route path="/read" element={<WorldPage />} />
      <Route path="/listen" element={<WorldPage />} />
      <Route path="/belong" element={<WorldPage />} />
      <Route path="/invite" element={<WorldPage />} />
      <Route path="/assessment" element={<Assessment />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/store" element={<Store />} />
      <Route path="/blade-grain" element={<BladeGrain />} />
      <Route path="/admin/orders" element={<ProtectedRoute><AdminOrders /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" toastOptions={{ style: { background: "#1E3A2B", color: "#FAF4E9", border: "1px solid #C0953A" } }} />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
